import { Group, Avatar, Stack, Text, Title } from "@mantine/core"
import { Card } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import type { InvitedCompanySummary } from "~/pages/SupplierPortal/Onboarding/verifyCompanyOutcome/verifyCompanyOutcome.types"

const SUMMARY_ROW_LABEL_WIDTH = "6rem"

type SummaryRowProps = Readonly<{
  label: string
  value: string
}>

const SummaryRow = ({ label, value }: SummaryRowProps) => (
  <Group justify="space-between" align="flex-start" w="100%" wrap="nowrap">
    <Text
      component="span"
      size="xs"
      c="var(--tfg-text-color-secondary)"
      fw={500}
      w={SUMMARY_ROW_LABEL_WIDTH}
      miw={SUMMARY_ROW_LABEL_WIDTH}
    >
      {label}
    </Text>
    <Text component="p" size="sm" m={0} ta="left" style={{ flex: 1 }}>
      {value}
    </Text>
  </Group>
)

type VerifyCompanySummaryCardProps = Readonly<{
  company: InvitedCompanySummary
}>

export const VerifyCompanySummaryCard = ({
  company,
}: VerifyCompanySummaryCardProps) => {
  const { t } = useTranslation("supplier")
  const initials = useMemo(
    () =>
      company.name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase(),
    [company.name]
  )

  return (
    <Card p="var(--tfg-organism-padding-y)" bg="var(--mantine-color-gray-0)">
      <Group align="flex-start" gap="var(--tfg-molecule-padding-x)">
        <Avatar size="lg" radius="md" color="primary">
          {initials}
        </Avatar>
        <Stack gap="var(--tfg-molecule-padding-y)" align="stretch">
          <Title order={4} m={0}>
            {company.name}
          </Title>
          <SummaryRow
            label={t("onboarding.verifyCompany.summary.street")}
            value={company.street}
          />
          <SummaryRow
            label={t("onboarding.verifyCompany.summary.city")}
            value={company.city}
          />
          <SummaryRow
            label={t("onboarding.verifyCompany.summary.country")}
            value={company.country}
          />
        </Stack>
      </Group>
    </Card>
  )
}
